import {combineReducers} from "redux";
import useReducer from "./user";
import sceneReducer from "./scene";
import workspaceReducer from "./workspace";
const rootReducers = combineReducers({
  userReducer: useReducer,
  workspaceReducer:workspaceReducer,
  sceneReducer : sceneReducer
});

export default rootReducers;
